import React, { useState } from "react";
import { Form, Row, Col, message, Button, Divider } from "antd";
import { useDispatch } from "react-redux";
// component
import LoginFormEmail from "./form_email";
import LoginFormPassword from "./form_password";
import LoginFormRemember from "./form_remember";
// redux
import { firebaseLogin } from "store/user/login/login.action";
import FormGoogle from "./form_google";
import ForgetPassword from "./form_forget";

const LoginForm = () => {
  // -------------------------- STATE --------------------------
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  // -------------------------- REDUX --------------------------
  const dispatch = useDispatch();

  // -------------------------- FUNCTION --------------------------
  const onFinish = (values) => {
    setLoading(true);
    dispatch(
      firebaseLogin({ login: values }, (response) => {
        if (response.status === 200) {
          message.success(response.data);
        } else if (response.status === 500) {
          setLoading(false);
          message.error(response.data);
        }
      }),
    );
  };
  // -------------------------- MAIN --------------------------
  return (
    <Form
      name="normal_login"
      initialValues={{ remember: true }}
      autoComplete="off"
      form={form}
      onFinish={onFinish}
    >
      <Row gutter={[16, 0]}>
        <Col xl={24} lg={24} md={24} xs={24}>
          <FormGoogle />
        </Col>
        <Divider />
        <Col xl={24} lg={24} md={24} xs={24}>
          <LoginFormEmail disabled={loading} />
        </Col>
        <Col xl={24} lg={24} md={24} xs={24}>
          <LoginFormPassword disabled={loading} />
        </Col>
        <Col xl={24} lg={24} md={24} xs={24} className="flex justify-between">
          <LoginFormRemember disabled={loading} />
          <ForgetPassword disabled={loading} />
        </Col>
        <Col xl={24} lg={24} md={24} xs={24}>
          <Button
            type="primary"
            htmlType="submit"
            className="login-form-button"
            style={{ width: "100%", marginBottom: 10 }}
            loading={loading}
            disabled={loading}
          >
            Đăng nhập
          </Button>
        </Col>
      </Row>
    </Form>
  );
};

export default LoginForm;
